// Presentation helpers ported from public/assets/app.js — kept client-side so the
// API stays raw (value + count) and labels live in one place.
import type { CatalogItem, SortMode } from "./types";

const compactNumber = new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 });
export const wholeNumber = new Intl.NumberFormat("en-US");

// Era category slugs that read poorly as-is. Values stay raw for filtering.
export function categoryLabel(value: string): string {
  return ({ threed: "3d", notlisted: "uncategorized" } as Record<string, string>)[value] || value;
}

// Source slugs whose pretty name isn't just the bare domain.
export function sourceLabel(domain: string): string {
  const named: Record<string, string> = { playforia: "Playforia", "addictinggames.com": "AddictingGames" };
  if (named[domain]) return named[domain];
  return domain.replace(/\.(com|net|org|io)$/, "");
}

// The card meta line, matching cardHtml() in app.js.
export function cardMeta(item: CatalogItem, sort: SortMode): string {
  const plays = item.playCount > 0 ? item.playCount : 0;
  const parts =
    sort === "plays"
      ? [plays ? `${compactNumber.format(plays).toLowerCase()} plays` : "plays unknown", categoryLabel(item.category || "")]
      : [categoryLabel(item.category || ""), item.runtime || ""];
  if (item.playability === "queued" && sort === "plays") parts.push("held");
  return parts.filter(Boolean).join(" · ");
}
